export default "__VITE_ASSET__VL6OEKNB__"